import { FC, useEffect } from 'react'
import Select from '../input/Select'
import { useTemplateProjectId } from 'src/query/useTemplateProjectId'
import { ArrowRightOutlined } from '@ant-design/icons'
import { useTemplateCanvas } from 'src/hooks/useTemplateCanvas'
import { DatePicker, Empty, Image, Spin } from 'antd'
import useMigrateStore from './useMigrateStore'
import { useStableCallback } from 'src/hooks/useStableCallback'

interface MigrationSelectTimelineProps {
  canMove: (canMove: boolean) => void
}

const MigrationSelectTimeline: FC<MigrationSelectTimelineProps> = ({
  canMove,
}) => {
  const {
    templateId: selectedTemplateId,
    destinationProjectId,
    setDestinationProjectId,
    startDate,
    setStartDate: setNewStartWeek,
    setTemplateId: setSelectedTemplateId,
  } = useMigrateStore()
  const { projects, templateProjectId, templates } = useTemplateProjectId()

  const stableCanMove = useStableCallback(canMove)

  useEffect(() => {
    stableCanMove(!!selectedTemplateId && !!destinationProjectId && !!startDate)
  }, [selectedTemplateId, destinationProjectId, startDate, stableCanMove])

  const canvas = useTemplateCanvas(templates, selectedTemplateId)
  return (
    <div className="p-5 flex flex-col bg-gray-50 bg-opacity-50 rounded w-full h-full">
      <div className="flex w-full gap-5 items-center">
        <div className="w-1/2">
          <Select
            onChange={setSelectedTemplateId}
            name={['name', 'projectName']}
            value={selectedTemplateId}
            label={'Select Timeline template'}
            items={templates}
            id={'id'}
            separator={([name, projectName]) => `${name} (${projectName})`}
          />
          {selectedTemplateId && (
            <Select
              onChange={console.log}
              name={['projectNumber', 'projectName']}
              value={templateProjectId}
              disabled
              label={'Selected Template Project'}
              items={projects}
              id={'id'}
            />
          )}
        </div>
        {selectedTemplateId && <ArrowRightOutlined />}
        {selectedTemplateId && (
          <div className="w-1/2">
            <Select
              onChange={setDestinationProjectId}
              name={['projectNumber', 'projectName']}
              value={destinationProjectId}
              label={'Destination Project'}
              items={projects.filter((p) => p.id !== templateProjectId)}
              id={'id'}
              separator=" - "
            />

            <div className="flex flex-col gap-2">
              <div className="">New Starting Week</div>
              <DatePicker
                picker="week"
                value={startDate}
                onChange={(a) => a && setNewStartWeek(a)}
              />
            </div>
          </div>
        )}
      </div>
      <div className=" w-full h-full flex items-center justify-center rounded-lg r ">
        {canvas.loading ? (
          <div className="flex items-center justify-center w-full h-full">
            <Spin size="large" />
          </div>
        ) : canvas.templateCanvas ? (
          <div className="overflow-auto aspect-square w-full flex max-h-[60vh] justify-center">
            <Image src={canvas.templateCanvas} width={window.innerWidth} />
          </div>
        ) : (
          <Empty />
        )}
      </div>
    </div>
  )
}

export default MigrationSelectTimeline
